import styled from '@emotion/styled';

export const EventsWrapper = styled('div', { label: 'EventsWrapper' })<{visible: boolean}>`
    pointer-events: ${({visible}): string => visible ? 'all' : 'none'};
    opacity: ${({visible}): string => visible ? '1' : '0'};
`;
